import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from '../ApiEvs.service';

@Injectable()
export class AdminIvrGatewayService extends ApiEvsService {
  constructor(http: Http, router: Router) {
    super(http, router);
  }

  list(tenant_id, query?: any) {
    return this.get('/v2/admin/settings/ivrgateway/' + tenant_id, query);
  }
  all(tenant_id, query?: any) {
    return this.get('/v2/admin/settings/ivrgateway/' + tenant_id + '/all', query);
  }
  create(tenant_id, body: any) {
    return this.post('/v2/admin/settings/' + tenant_id + '/ivrgateway', body);
  }
  _update(tenant_id, id, body) {
    return this.put('/v2/admin/settings/' + tenant_id + '/ivrgateway/' + id, body);
  }
  _delete(tenant_id, id) {
    return this.delete('/v2/admin/settings/ivrgateway/' + tenant_id + '/' + id);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/admins/ivrGateway.service.ts